import React, { useRef, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { axiosEH } from './common/functions'
import { showResultArr } from './common/functions'
import './spellingbee.css';
import linkAvatars from './linkAvatars-dev.txt';
import jwtUser from '../jwtUser';


export default function SpellingBee() {
  const user = jwtUser(); // get user token
  const avaDefaultURL = `${process.env.PUBLIC_URL}/Assets/Images/spellingbee.jpg`;
  const location = useLocation().state.taskId;
  const msgColor = 'black';
  const bgColors = ['#F8F8FF', '#fffafa', '#add8e6', '#0892d0', '#355e3b', ' #9acd32', '#282C35', '#0f0f0f', '#ffe5b4', '#ffb347', '#c9a0dc', '#8a2be2', ' #b38b6d', '#cd7f32', '#f5f5f5', '#848482']
  let bgColorIndex = 0, wordArr = [];
  let statusLabel = document.getElementById('statusLabel#');  // null: init value

  const wordIndex = useRef(0);
  const score = useRef(0);
  const sbArr = useRef([['word no', 'test word', 'input word', 'status', 'score']]);
  
  const [sentenceArr, setSentenceArr] = useState([]);
  const [avatarURL, setAvatarURL] = useState(avaDefaultURL);
  const [avaURLArr, setAvaURLArr] = useState([]);

  const changeBackground = () => {
    if (bgColorIndex >= bgColors.length) bgColorIndex = 0;
    document.body.style.backgroundColor = bgColors[bgColorIndex];
    //console.log("bgColorIndex: ", bgColorIndex);
    ++bgColorIndex;
  }

  function getSBwordArr(arr) {
    let wArr = [], temp;

    for (let i = 0; i < arr.length; i++) {
      temp = arr[i].split('--')[0].trim();
      if (temp) {  // only add non-empty word
        wArr.push(temp);
      }
    }
    //console.log('wArr: ', wArr);
    return wArr;
  }

  function playTTS(isBegin, isAuto, isStop, str) {
    //console.log("TTS args: ", isBegin, isAuto, isStop, str);
    const audioEl = document.getElementById('TTSAudio');
    const TTSurl = process.env.REACT_APP_BASEURL + `/tts/?text=${str}`;
    //console.log('TTSurl: ', TTSurl);

    audioEl.src = isStop ? '' : TTSurl;
    if (isBegin) {
      score.current = 0; wordIndex.current = 0;
      //beginAudio.mp3, test.mp3
      audioEl.src = process.env.PUBLIC_URL + `/wordAudio/beginMsg-Owen.mp3`;
    }
    if (isAuto) {
      audioEl.play();
    }

    // submitted
    if (isBegin == false && isAuto == true & isStop == false){
      setTimeout(() => {
        console.log('sbArr.current: ', sbArr.current);
        showResultArr(sbArr.current);
        window.location.href = "/task";
      }, 4000);
    }
  };

  function onplayHandler() {
    //return;
    //let temp;
    if (wordIndex.current < sentenceArr.length) {
      setAvatarURL(avaURLArr[wordIndex.current]);
    } else {
      setAvatarURL(avaDefaultURL);
    }
    //console.log('onplay: ', wordIndex.current, avaURLArr[wordIndex.current], avatarURL);
  }

  // case insensitive & forms
  function createMsg(combinedSentence, tWord) {
    const defaultMsg = "Input the first word you heard";
    let arr, sentence, pMsg ='';
    const regex = new RegExp('\\b' + tWord + '\\b', 'gi');

    //a--That is a book--a
    arr = combinedSentence.split("--")
    if (arr.length >1) {
      sentence = arr[1];
      sentence = sentence.replace(regex, " ___ ");
      pMsg = sentence + "\n" + defaultMsg;
    } else {
      pMsg = defaultMsg;
    }
    return pMsg;
  }

  const len = sentenceArr.length;
  let scoreString = '';
  function onendedHandler() {
    let inputWord = '', testWord;
    let promptMsg = '';
    statusLabel = document.getElementById('statusLabel#');

    // case 1. stop the controls
    if (wordIndex.current == len) {
      playTTS(false, false, true, '');  // STOP: isBegin, isAuto, isStop
      //window.location.reload(); 
      return;
    }

    //console.log('onEnded: ', wordIndex.current, sentenceArr[wordIndex.current], score.current);
    // case 2. 1st one [0], reset
    if (wordIndex.current == 0) {
      sbArr.current = [['word no', 'test word', 'input word', 'status', 'score']];
      score.current = 0;
      playTTS(false, false, false, sentenceArr[wordIndex.current + 1]); // isBegin, isAuto, isStop
      wordIndex.current += 1;
      return;
    }

    // case 3. middle ones [1]
    playTTS(false, false, false, sentenceArr[wordIndex.current + 1]);  // isBegin, isAuto, isStop
    // trim spaces
    testWord = sentenceArr[wordIndex.current].split("--")[0].trim();
    promptMsg = createMsg(sentenceArr[wordIndex.current], testWord);
    const t0 = performance.now();
    inputWord = prompt(promptMsg);
    const t1 = performance.now();
    let t1sec = (t1 - t0) / 1000; t1sec = parseInt(t1sec);
    //const timeout = parseInt(sessionStorage.getItem('sc-spellingTimeoutSec'));
    const timeout = 60;

    if (inputWord == null) {
      sbArr.current.push([wordIndex.current, testWord, '', 'canceled', score.current]);
    } else if (t1sec < timeout) {
      inputWord = inputWord.trim();
      if (inputWord.toLowerCase() == testWord.toLowerCase()) {
        score.current += 1;
        sbArr.current.push([wordIndex.current, testWord, inputWord, 'v', score.current]);
      } else {
        sbArr.current.push([wordIndex.current, testWord, inputWord, 'x', score.current]);
      }
    } else {
      inputWord = inputWord.trim();
      sbArr.current.push([wordIndex.current, testWord, '', `timeout:${t1sec}s`, score.current]);
    }
    scoreString = `score ${score.current} of ${wordIndex.current}`;
    statusLabel.innerHTML = scoreString;

    // case 4. the last one []
    if (wordIndex.current == (len - 1)) {
      scoreString += '.' + "The test finished";
      playTTS(false, true, false, scoreString);
      score.current = parseInt(100 * score.current / (len - 1));
      sbArr.current.push(sentenceArr[0] + '-' + score.current); // filename
      //console.log("sbArr.current: ", sbArr.current);
      if (sbArr.current.length > 1) {
        postSBArr(sbArr.current);
      }
      //playTTS(false, false, true, '');  // STOP: isBegin, isAuto, isStop
    }
    wordIndex.current += 1;
  }

  async function getAvaURLArr2(wArr) {
    //wArr = ["demot-219-ES 2022-random-1741188368653-SB-demot","television","soup","house","shop","eightieth","student","sea","run","light","out","animal"  ];
    let temp, temp2, index, wordsArr = []; // reset to zero

    // 1. get the ava name arr
    const res = await axios.get(linkAvatars);
    const avaNameArr = res.data.trim('\n').split('\n');
    //console.log('avaNameArr:', avaNameArr);


    // 2. get ava URLs
    for (let iw = 0; iw < wArr.length; iw++) {
      let thisWordArr =[];

      // 3. ava entry loop
      for (let ia = 0; ia < avaNameArr.length; ia++) {
        // 31) blank
        if (avaNameArr[ia].length ==0) continue;

        // 32) 
        temp = avaNameArr[ia].split(",")
        if (temp.includes(wArr[iw])) {
          thisWordArr.push(temp[0])
        }
      }

      // 4. ava 3 cases
      if(thisWordArr.length ==0 ){
        wordsArr.push(avaDefaultURL)
      } else  if(thisWordArr.length ==1 ){
        wordsArr.push(`${process.env.PUBLIC_URL}/avatars/${thisWordArr[0]}`);
      } else {
        index = Math.floor( Math.random() * thisWordArr.length )
        wordsArr.push(`${process.env.PUBLIC_URL}/avatars/${thisWordArr[index]}`);
      }
    }
    setAvaURLArr(wordsArr);  // arr: ['/Assets/Images/spellingbee.jpg', '/avatars/ship.svg']
    //console.log('wArr, wordsArr:',wArr, wordsArr);
  }

  /* get tp: "x" for err, [] for ok
  sentenceArr[0] for report file name & ogg name
  */
  async function getTask() {
    const url = process.env.REACT_APP_BASEURL + `/usertasks/${location}`;

    const res = await axios.get(url, { headers: { 'x-access-token': user['x-access-token'] } });
    console.log('res.data type & len:', Object.prototype.toString.call(res.data), res.data.length);
    //res.data = ['demot-244-ES 2022-R-3528-SB-demot', 'October--October 1st is national holiday in China--October', 'play--I play chess--play', 'can--Can I help you--can', 'apple--Give these six apples to Jenny--apple', 'good--We should find a better solution--good','grandparent'];
    if (Object.prototype.toString.call(res.data) == '[object Array]') {
      res.data = res.data.filter(function (e) { return e });  // 2nd remove all empty arr el
      setSentenceArr(...[res.data]);
      wordArr = getSBwordArr(res.data);
      getAvaURLArr2(wordArr);
    } else {  // nok ""
      setSentenceArr([0]);  // make len 0
    }
  }

  function postSBArr(data) {
    //alert(data);
    const url = process.env.REACT_APP_BASEURL + `/userspelling`;
    axios.post(url, { sbArr: data}, { headers: { 'x-access-token': user['x-access-token'] } })
      .then(res => {
        console.log('test result sent to server succeeded');
        //statusLabel.innerHTML='test result sent to server succeeded';
      })
      .catch(err => {
        setStatusMsg(axiosEH(err));
      })
  }
  //console.log('bf useEffect: avaURLArr:', avaURLArr);

  useEffect(() => {
    getTask();
    //getAvaURLArr2(wordArr);  // dft
  }, []);   // []: render once only

  return (
    <div className="container">

      <div className="music-Container">
        <p style={{ color: 'blue' }}>SpellingBee Player</p>
        {/* <img id='wAvatar' src={avatarURL} alt="word avatar" style={{width:'80%',height:'80%'}} /> */}
        <img id='wAvatar' src={avatarURL} alt="word avatar" />
        <label style={{ color: msgColor }}>Total words: {sentenceArr.length - 1}</label>
        {sentenceArr.length > 1 && <button onClick={() => { playTTS(true, true, true, '') }} >(Re)Begin</button>}
        <audio id='TTSAudio' controls onPlay={() => { onplayHandler() }} onEnded={() => { onendedHandler() }}></audio>
        <label id="statusLabel#" style={{ color: msgColor }}></label>
      </div>

      <div className="changeBackgroundBtn" onClick={changeBackground}>
        Change Background
      </div>

    </div>
  );
}